//* Importing  UseState from react
import { useState } from "react";

//* Importing components from react-bootstrap
import { Container, Row, Col, Button } from "react-bootstrap";

//* Importing hooks from react-router-dom
import { useParams, useNavigate } from "react-router-dom";

//* Importing StudentList component from view
import StudentList from "../view/StudentList";

export function ClassManager(props: { id?: string }) {
  const navigate = useNavigate();
  const params = useParams();
  const [teamId, setTeamId] = useState(params.id || "");

  function handleGoBack() {
    navigate(-1);
  }

  return (
    <Container className="py-4">
      <Row className="mb-3">
        <Col>
          <h4 className="mt-0 header-title fs-4 text-dark">
            Adicionar Alunos à Turma
          </h4>
        </Col>
        <Col className="text-end">
          <Button variant="secondary" onClick={handleGoBack}>
            Voltar
          </Button>
        </Col>
      </Row>

      {teamId ? (
        <StudentList teamId={teamId} />
      ) : (
        <p>Não há identificação de turma disponível.</p>
      )}
    </Container>
  );
}
